import removeCart from "./removeCart";

const closeCart = function () {
  $('.close-cart').on('click', function () {
    $('.cart-content').removeClass('show');
  });
}

export function ajaxLoadCart() {
  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    method: 'POST',
    dataType: 'json',
    data: { action: 'load_cart' },
    success: function (response) {
      $('.cart-content').html(response.html);
      $('.cart-count').text(response.count);
      removeCart();
      closeCart();
    },
    error: function (xhr, textStatus, errorThrown) {
      console.log(xhr, errorThrown);
    }
  });
}

export default function loadCart() {
  $('.js-load-cart').on('click', () => {
    $('.cart-content').stop().toggleClass('show');
    if ($('.cart-content').hasClass('show')) {
      ajaxLoadCart();
    }
  });
}
